import config from 'config';

// This remarketing flow is used for changing payment method
export const REMARKETING_FLOW_LINK = `${config.SURVEY_URL}?branch-name=email&test-name=go16agl`;

export const CHANGE_PAYMENT_METHOD_QUERY_NAME = 'changePaymentMethod';

export const PAYMENT_METHOD_IS_CHANGED_QUERY_NAME = 'paymentMethodIsChanged';
